export default __webpack_public_path__ + "static/media/mastercard.05849232.svg";